import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutCouple from './components/AboutCouple';
import ProductShowcase from './components/ProductShowcase';
import Opportunity from './components/Opportunity';
import Footer from './components/Footer';
import FloatingCallButton from './components/FloatingCallButton';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white selection:bg-emerald-100 selection:text-emerald-900">
        <Navbar />
        <main>
          <Hero />
          <AboutCouple />
          <ProductShowcase />
          <Opportunity />
        </main>
        <Footer />
        <FloatingCallButton />
      </div>
    </Router>
  );
}

export default App;